
export class AirportProperties {
  id: number;
  iataCode: string;
  airportName: string;
  city: string;
  country: string;
  status: string;
  combineAirportFrom: string;
  combineAirportTo: string;
  userId: number = 0;
  
}
